@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_cus

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.enginetabular.TabularScreen
import org.example.project.enginetabular.allFromTabularCommit
import org.example.project.service.YardApi
import org.example.project.utils.All

@Composable
fun CUSPalettenArtenVerwaltung(art: String = org.example.project.service.currentSaveArt()) {
    var items by remember { mutableStateOf<List<All>>(emptyList()) }
    val scope = rememberCoroutineScope()
    LaunchedEffect(art) {
        val existing = try { YardApi.loadPalettenDefinitionen() } catch (_: Throwable) { emptyList() }
        if (existing.isEmpty()) {
            standardPalettenArten.forEach { YardApi.savePalettenDefinition(it) }
            items = standardPalettenArten
        } else {
            items = existing.distinctBy { it.id }.sortedBy { it.id.toIntOrNull() ?: 0 }
        }
    }

    val headers = listOf("ID", "Bezeichnung", "Aktiv WE", "Aktiv WA")
    val saveFields = listOf("id", "bezeichnung", "aktivWe", "aktivWa")

    TabularScreen(
        screenKey = "PalettenArtenVerwaltung_${art}",
        rollenKey = "PalettenArtenVerwaltung",
        title = "Palettenarten Verwaltung (${art})",
        headers = headers,
        models = items,
        data = items.map { def ->
            def.id to listOf(
                def.id,
                def.bezeichnung,
                if (def.aktivWe) "✅" else "⬜",
                if (def.aktivWa) "✅" else "⬜"
            )
        },
        editable = true,
        nonEditableCols = setOf("ID"),
        createRow = { _ ->
            val nextId = ((items.maxOfOrNull { it.id.toIntOrNull() ?: 0 } ?: 0) + 1).toString()
            listOf(nextId, "", "⬜", "✅")
        },
        onCommit = { rows ->
            scope.launch {
                rows.forEach { (id, cols) ->
                    val existing = items.firstOrNull { it.id == id }
                    val toSave = allFromTabularCommit(
                        id,
                        listOf(
                            id,
                            cols[1],
                            if (cols[2] == "✅") "true" else "false",
                            if (cols[3] == "✅") "true" else "false"
                        ),
                        saveFields
                    )
                    if (existing != toSave) {
                        YardApi.savePalettenDefinition(toSave)
                    }
                }
            }
        },
        onDeleteRows = { ids -> ids.forEach { id -> YardApi.deletePalettenDefinition(id) } }
    )
}

val standardPalettenArten: List<All> = listOf(
    All(id = "1", kontrollId = "1", bezeichnung = "Vollpalette CCG1", aktivWe = false, aktivWa = true),
    All(id = "2", kontrollId = "2", bezeichnung = "Vollpalette CCG2", aktivWe = false, aktivWa = true),
    All(id = "3", kontrollId = "3", bezeichnung = "Mischpalette CCG1", aktivWe = false, aktivWa = true),
    All(id = "4", kontrollId = "4", bezeichnung = "Mischpalette CCG2", aktivWe = false, aktivWa = true)
)
